import type { NormalizeOAS, OASModel, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/export-project/setting/{projectId}', 'get'>;
type ResponseItemTreeNodeDto = OASModel<O, 'ProjectExportSettingPageQuery.ItemTreeNodeDto'>;
type ResponseBody = OASOutput<O, '/api/export-project/setting/{projectId}', 'get'>;

export type QuizListItem = {
  name: string;
  guid: string;
};

export type ItemTreeNode = {
  id: number;
  name: string;
  type: number;
  isMandatory: boolean;
  children: ItemTreeNode[];
};

type Params = {
  projectId: number;
};

type Result = {
  quizes: QuizListItem[];
  items: ItemTreeNode[];
};

export const getProjectQuizesFactory = (apiClient: ApiClient) => {
  const getProjectQuizes = async (variables: Params): Promise<Result> => {
    const requestParams = mapInputToRequestParams(variables);
    const response = await apiClient['/api/export-project/setting/{projectId}'].get(requestParams);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      params: {
        projectId: input.projectId,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      quizes: response.quizes.map((item) => ({
        name: item.name,
        guid: item.guid,
      })),
      items: response.items.map((item) => mapItemTreeNode(item)),
    };
  };

  const mapItemTreeNode = (item: ResponseItemTreeNodeDto): ItemTreeNode => ({
    id: item.id,
    name: item.name,
    type: item.type,
    isMandatory: item.isMandatory,
    children: (item.children as ResponseItemTreeNodeDto[]).map(mapItemTreeNode),
  });

  return getProjectQuizes;
};
